export default function ({ glideBehaviour, carouselId, startAt }) {
    // if the carousel is a child inside fx. ThemeSection it needs to change according to the parents width and not the viewport, so we need to:

    // 1. find the caseCarousel and select it
    const podcastCarousel = document.querySelector(`#${carouselId}`)

    // 2. find the parent and select it
    const parent = podcastCarousel.parentNode

    // 3. find parent's width (maybe with .offsetWidth)
    const parentWidth = parent.offsetWidth

    // 4. change slider configs for cards according to the width of the parent instead of viewport.

    let glideConfig = {
        type: glideBehaviour,
        startAt: startAt ?? 0,
        perView: 3.95,
        gap: 32,
        peek: {
            after: 275,
            before: 0
        }
    }

    if (glideBehaviour === 'slider') {
        glideConfig.rewind = false
        glideConfig.bound = true
    }

    if (parentWidth < 400) {
        return Object.assign(glideConfig, {
            perView: 1.1,
            gap: 32,
            peek: {
                after: 50,
                before: 0
            }
        })
    } else if (parentWidth < 500) {
        return Object.assign(glideConfig, {
            perView: 1.6,
            gap: 32,
            peek: {
                after: 50,
                before: 0
            }
        })
    } else if (parentWidth < 700) {
        return Object.assign(glideConfig, {
            perView: 2.1,
            gap: 32,
            peek: {
                after: 75,
                before: 0
            }
        })
    } else if (parentWidth < 800) {
        return Object.assign(glideConfig, {
            perView: 2.6,
            gap: 32,
            peek: {
                after: 70,
                before: 0
            }
        })
    } else if (parentWidth < 1000) {
        return Object.assign(glideConfig, {
            perView: 3.2,
            gap: 32,
            peek: {
                after: 70,
                before: 0
            }
        })
    } else if (parentWidth < 1200) {
        return Object.assign(glideConfig, {
            perView: 3.8,
            gap: 32,
            peek: {
                after: 160,
                before: 0
            }
        })
    } else {
        return glideConfig
    }
}
